(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1558],{

/***/ 1017:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/discovery",
      function () {
        return __webpack_require__(1122);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ discovery; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./styles/pages/styled/services/discovery.styles.tsx

const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "exovrgw0"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";");

// EXTERNAL MODULE: ./components/sections/ProductDesign/Parallax/Parallax.tsx + 1 modules
var Parallax = __webpack_require__(23770);
// EXTERNAL MODULE: ./models/enums/titleAs.ts
var titleAs = __webpack_require__(79794);
;// CONCATENATED MODULE: ./pages/services/discovery.tsx







const DynamicWhyYouNeedDiscovery = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2200).then(__webpack_require__.bind(__webpack_require__, 12200)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(12200)
            ]
    }
});
const DynamicTestimonial = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4453).then(__webpack_require__.bind(__webpack_require__, 94453)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(94453)
            ]
    }
});
const DynamicServiceTeam = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1224).then(__webpack_require__.bind(__webpack_require__, 11224)).then((mod)=>mod.ServiceTeam), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(11224)
            ]
    }
});
const DynamicOurProcess = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9637).then(__webpack_require__.bind(__webpack_require__, 29637)).then((mod)=>mod.OurProcess), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(29637)
            ]
    }
});
const Discovery = (param)=>{
    let { data: { page  }  } = param;
    const section = page.sections.map((section)=>({
            title: prismic_reactjs.RichText.asText(section.title),
            subtitle: prismic_reactjs.RichText.asText(section.subtitle),
            description: prismic_reactjs.RichText.asText(section.description),
            subDescription: prismic_reactjs.RichText.asText(section.sub_description),
            subtitleInfo: prismic_reactjs.RichText.asText(section.subtitle_info),
            image: section.image || {}
        }));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        className: "development",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Parallax/* Parallax */.V, {
                name: "development",
                page: page,
                sections: section,
                additionalClassName: "parallax-development",
                backButtonColor: "white"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicWhyYouNeedDiscovery, {
                title: prismic_reactjs.RichText.asText(page.whyyouneeddiscovery_title),
                subtitle: prismic_reactjs.RichText.asText(page.whyyouneeddiscovery_title2),
                description: prismic_reactjs.RichText.asText(page.whyyouneeddiscovery_description),
                steps: page.whyyouneeddiscovery_steps,
                titleAs: titleAs/* TitleAs.h3 */.P.h3
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicOurProcess, {
                id: "discovery",
                title: prismic_reactjs.RichText.asText(page.discovery_process_title),
                subtitle: page.discovery_process_subtitle,
                items: page.discovery_process_diagram,
                titleAs: titleAs/* TitleAs.h4 */.P.h4
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicServiceTeam, {
                title: prismic_reactjs.RichText.asText(page.discovery_team_title),
                positions: page.team_positions,
                image: page.discovery_team_image,
                titleAs: titleAs/* TitleAs.h5 */.P.h5
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicTestimonial, {
                additionalClassName: "product-design__testimonial",
                title: prismic_reactjs.RichText.asText(page.what_is_like_to_title),
                quote: page.what_is_like_to_quote,
                caseName: prismic_reactjs.RichText.asText(page.what_is_like_to_author),
                casePosition: prismic_reactjs.RichText.asText(page.what_is_like_to_person_position),
                caseStudy: true,
                titleAs: titleAs/* TitleAs.h6 */.P.h6
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var discovery = (Discovery);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1880,9774,2888,179], function() { return __webpack_exec__(1017); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);